package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class BudgetQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> all(mapper: (
    categoryId: String,
    limitCents: Long,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(-947_394_489, arrayOf("BudgetEntity"), driver, "Budget.sq", "all",
      "SELECT BudgetEntity.categoryId, BudgetEntity.limitCents, BudgetEntity.isDeleted, BudgetEntity.createdAtEpochMs, BudgetEntity.updatedAtEpochMs FROM BudgetEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getBoolean(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!
    )
  }

  public fun all(): Query<BudgetEntity> = all { categoryId, limitCents, isDeleted, createdAtEpochMs,
      updatedAtEpochMs ->
    BudgetEntity(
      categoryId,
      limitCents,
      isDeleted,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    categoryId: String,
    limitCents: Long,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(-1_022_533_431, """INSERT OR REPLACE INTO BudgetEntity VALUES (?, ?, ?, ?, ?)""",
        5) {
          bindString(0, categoryId)
          bindLong(1, limitCents)
          bindBoolean(2, isDeleted)
          bindLong(3, createdAtEpochMs)
          bindLong(4, updatedAtEpochMs)
        }.await()
    notifyQueries(-1_022_533_431) { emit ->
      emit("BudgetEntity")
    }
  }
}
